var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"homowork"}},[_c('quillEditor',{staticStyle:{"height":"100%"},attrs:{"conter":_vm.content},on:{"EditorFrom":_vm.fnInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }